/**
 * #4619 Slice 2 — the SEMANTIC SELECTION a turn resolved, on the narration wire.
 *
 * The runtime already resolves a (capabilityId, intentId) pair for every
 * validated governed call, and Slice 1 gave the manifest intent a declarative
 * `executiveAnswerContract`. This type is the thin, additive carrier that puts
 * that resolution — and the intent's declared contract, when one exists — onto
 * the narration request, exactly as FIX-3's `askedFocus` carried the anchor
 * set.
 *
 * Inert by design: declaring it changes NO runtime behaviour today. Absent on
 * every request with no single resolved selection (legacy bridge, brief, LRP,
 * composite turns whose lanes disagree), which keeps those payloads
 * byte-identical. The answer-context compiler and outbound validator (later
 * slices) are the consumers; until they land, only a shadow counter observes
 * whether the field was populated.
 */
import type { ExecutiveAnswerContract } from './executive-answer-contract';

export type AskHelixSemanticSelection = Readonly<{
  /** The governed capability the validated call resolved. */
  capabilityId: string;
  /** The manifest intent the validated call resolved. */
  intentId: string;
  /**
   * The resolved intent's declared answer contract (#4619 Slice 1), or null
   * when the intent declares none. Module-owned data, never authored here.
   */
  executiveAnswerContract?: ExecutiveAnswerContract | null;
}>;
